/**
 * @generated SignedSource<<f3e676eacf376faa6fd22a2605bbc902>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AudienceGroupsFragment$data = {
  readonly nodes: ReadonlyArray<{
    readonly id: string;
    readonly items: ReadonlyArray<{
      readonly label: string;
    }>;
    readonly label: string;
    readonly position: number;
  }>;
  readonly " $fragmentType": "AudienceGroupsFragment";
};
export type AudienceGroupsFragment$key = {
  readonly " $data"?: AudienceGroupsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AudienceGroupsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AudienceGroupsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AudienceGroup",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "position",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AudienceGroupItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v0/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AudienceGroupConnection",
  "abstractKey": null
};
})();

(node as any).hash = "55ec03bdd21399a2dbf0d739f6adf6a2";

export default node;
